/**
 * Optimizes an image URL from Storyblok by appending a size modifier to the path.
 *
 * - If the URL is empty, returns an empty string.
 * - If the URL does not contain "storyblok.com", returns the original URL.
 * - If the URL ends with ".svg", returns the original URL (SVGs are not optimized).
 * - Otherwise, appends `/m/{size}` to the base URL, preserving any existing query parameters.
 *
 * @param url - The original image URL to optimize.
 * @param size - Optional size string to append for optimization (e.g., "600x400").
 * @returns The optimized image URL, or the original URL if not applicable.
 */
export default function optimizeImage(url: string, size?: string): string {
  if (!url) return "";
  if (!url.includes("storyblok.com")) return url;
  if (String(url).endsWith(".svg")) return url;

  const [baseUrl, query] = url.split("?");
  let optimizedUrl = baseUrl + "/m/";

  if (size && size.length > 0) {
    optimizedUrl += size;
  }

  if (query) {
    optimizedUrl += "?" + query;
  }

  return optimizedUrl;
}
